import axiosGraphQL from './GraphQL/axiosGraphQL';

const getSapDebtClearingDataQuery = `
query GetSapDebtClearingData($input: debtClearingInput!, $skip: Float!, $take: Float!) {
  getSapDebtClearingData(input: $input, skip: $skip, take: $take) {
    pageInfo {
      totalItems
      totalPages
      itemsPerPage
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      sapCustomerId
      orderId
      orderType
      documentCode
      soQ10
      soVnd
      poQ10
      poVnd
      sellDebtQ10
      sellDebtVnd
      buyDebtQ10
      buyDebtVnd
      createId
      createDate
      modifyId
      modifyDate
      sumPaymentId
      orderIdSale
      orderIdPurchase
      storeId
      tcreateUser {
        id
        fullName
      }
      tplant {
        id
        name
      }
    }
  }
}`;

const getCustomerDebitComparisonInfoQuery = `
query GetCustomerDebitComparisonInfo($input: RuleCustomerDebitComparisonInput!) {
  getCustomerDebitComparisonInfo(input: $input) {
    pageInfo {
      totalItems
      totalPages
      itemsPerPage
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      plantId
      teamSaleId
      sapCustomerId
      customerId
      mainCustomerId
      teamName
      storeName
      mainCustomerName
      comparisonYn
      goldThreadQ10Traditional
      dateQ10Traditional
      amountWagesTraditional
      dateWagesTraditional
      amountHighendLimit
      dateHighendLimit
      amountHighendTraditionalLimit
      dateHighendTraditionalLimit
      dmsCollectDebitAmount
      dmsCollectDebitQ10
      dmsPayDebitAmount
      dmsPayDebitQ10
      holdingProductQ10
      returnProductQ10
      longestDebtAge
      shortestDebtAge
      averageDebtAge
      receivedProductPoQ10
      pricePaymentNoSap
      sapPriceCollect
      sapPricePay
      sapQ10Keep
      sapQ10Temporary
      q10TemporaryMiro
      amountTemporaryMiro
      unitPrice
      unitQ10
      modifyDate
    }
  }
}`;

const getCustomerDebitComparisonSummaryQuery = `
query getCustomerDebitComparisonSummary($input: RuleCustomerDebitComparisonInput!) {
  getCustomerDebitComparisonSummary(input: $input) {
    pageInfo {
      totalItems
      totalPages
      itemsPerPage
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      plantId
      teamSaleId
      teamName
      comparisonYn
      quantityCustomerDebit
      dmsCollectDebitQ10
      dmsCollectDebitAmount
      quantityRuleCustomerDebit
      goldThreadQ10Traditional
      amountWagesTraditional
      quantityExceedLimit
      q10ExceedLimit
      amountExceedLimit
      dmsPayDebitAmount
      dmsPayDebitQ10
      pnjPayDebitQ10
      unitPrice
      unitQ10
      modifyDate
    }
  }
}`;

const getRuleCustomerDebitListQuery = `
query GetRuleCustomerDebitList($input: RuleCustomerDebitInput!, $skip: Float!, $take: Float!){
  getRuleCustomerDebitList(input: $input, skip: $skip, take: $take){
    pageInfo{
      hasNextPage
      hasPreviousPage
      itemsPerPage
      currentPage
      totalItems
      totalPages
    }
    items{
      id
      sapCustomerId
      plantId
      type
      goldThreadSalesLimit
      amountSalesLimit
      goldThreadQ10Traditional
      dateQ10Traditional
      amountHighendLimit
      dateHighendLimit
      amountHighendTraditionalLimit
      dateHighendTraditionalLimit
      amountWagesTraditional
      dateWagesTraditional
      createId
      createDate
      modifyId
      modifyDate
      effectiveTimeFrom
      effectiveTimeTo
      tcreateUser { id fullName }
      tmodifyUser { id fullName }
      ttype { id name }
      tplant { id name }
      tcustomer {
        id
        storeName
        sapCustomerId
        mainCustomer{ id sapCustomerId }
      }
    }
  }
}`;

const getCustomerDebitComparisonTHTTQuery = `
query GetCustomerDebitComparisonTHTT($input: CustomerDebitComparisonTHTTInput!) {
  getCustomerDebitComparisonTHTT(input: $input) {
    pageInfo {
      totalItems
      totalPages
      itemsPerPage
      currentPage
      hasNextPage
      hasPreviousPage
    }
    items {
      sumPaymentId
      createDate
      orderId
      purchaseId
      dmsPayDebitAmount
      dmsPayDebitQ10
      dmsCollectDebitAmount
      dmsCollectDebitQ10
      traditionCustomerDebitAmount
      traditionCustomerDebitQ10
      highendCustomerDebitQ10
      highendCustomerDebitAmount
      amountTraditionalHighendLimit
      plantId
      unitPrice
      unitQ10
      modifyDate
    }
  }
}`;

const getRuleCustomerDebitDetailQuery = `
query GetRuleCustomerDebitDetail ($input: RuleCustomerDebitDetailInput!){
  getRuleCustomerDebitDetail(input: $input) {
    customerDebtQ10DEB10_01
    customerDebtAmountDEB10_01
    customerDebtQ10DEB10_02
    customerDebtAmountDEB10_02
    customerDebtQ10DEB10_03
    customerDebtAmountDEB10_03
    sumPNJPDebitQ10
    sumPNJPDebitAmount
    debtDaysDEB10_01
    debtDaysDEB10_02
    debtDaysDEB10_03
    expiredDate_01
    expiredDate_02
    expiredDate_03
    vndTradable_01
    vndTradable_02
    vndTradable_03
    q10Tradable
    expiredDateQ10
    sumPaymentCustomerDebit {
      id
      customerId
      type
      pnjpDebitAmount
      pnjpDebitQ10
      customerDebitAmount
      customerDebitQ10
      createDate
      modifyDate
      dateDebit
      sumPaymentId
      ttype {
        id
        name
        note
        status
        createDate
        createId
        groupName
        email
        groupId
        managerEmail
        modifyDate
        modifyId
        sapId
        value
      }
    }
    ruleCustomerDebit {
      id
      sapCustomerId
      plantId
      type
      goldThreadSalesLimit
      amountSalesLimit
      goldThreadQ10Traditional
      dateQ10Traditional
      amountHighendLimit
      dateHighendLimit
      amountHighendTraditionalLimit
      dateHighendTraditionalLimit
      createId
      createDate
      modifyId
      modifyDate
      effectiveTimeFrom
      effectiveTimeTo
      amountWagesTraditional
    }
  }
}`;

const DebtApis = {
  getCustomerDebitComparisonInfo: (input: any) =>
    axiosGraphQL.post('/graphql', {
      query: getCustomerDebitComparisonInfoQuery,
      variables: { input },
    }),
  getCustomerDebitComparisonSummary: (input: any) =>
    axiosGraphQL.post('/graphql', {
      query: getCustomerDebitComparisonSummaryQuery,
      variables: { input },
    }),
  getRuleCustomerDebitList: (variables: any) =>
    axiosGraphQL.post('/graphql', {
      query: getRuleCustomerDebitListQuery,
      variables,
    }),
  getCustomerDebitComparisonTHTT: (input: any) =>
    axiosGraphQL.post('/graphql', {
      query: getCustomerDebitComparisonTHTTQuery,
      variables: { input },
    }),
  getRuleCustomerDebitDetail: (input: {
    customerId: string;
    plantId: string;
  }) =>
    axiosGraphQL.post('/graphql', {
      query: getRuleCustomerDebitDetailQuery,
      variables: { input },
    }),
  getSapDebtClearingData: (input: any, skip: number, take: number) =>
    axiosGraphQL.post('/graphql', {
      query: getSapDebtClearingDataQuery,
      variables: { input, skip, take },
    }),
  updateCustomerDebit: (input: any) =>
    axiosGraphQL.post('/graphql', {
      query: `mutation UpdateCustomerDebit($input: UpdateSumPaymentCustomerDebitInput!) {
        updateSumPaymentCustomerDebit(input: $input) {
          code
          success
          message
        }
      }`,
      variables: { input },
    }),
};

export default DebtApis;
